import {
  useRef,
} from 'react';
import {
  useGSAP,
} from '@gsap/react';
import gsap from 'gsap';
import {
  CustomEase,
} from 'gsap/CustomEase';
import {
  MotionPathPlugin,
} from 'gsap/MotionPathPlugin';
import {
  ScrollTrigger,
} from 'gsap/ScrollTrigger';
import {
  Autoplay,
} from 'swiper/modules';
import {
  Swiper,
  SwiperSlide,
} from 'swiper/react';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import InstallButton from '@/components/InstallButton';
import Marquee from '@/components/Marquee';
import ItemStatic from '@/components/Static/ItemStatic';
import ReviewStatic from '@/components/Static/ReviewStatic';
import WishlistLinkStatic from '@/components/Static/WishlistLinkStatic';
import {
  EXTENSION_URL,
} from '@/constants';
import Text from '@/ui/components/Text';
import {
  ProgressShape,
} from '@/ui/shapes';

import styles from './page.module.css';

gsap.registerPlugin(
  CustomEase,
  ScrollTrigger,
  MotionPathPlugin,
  useGSAP,
);

CustomEase.create('bouncy', '1, -0.3, 0.35, 1.45');
CustomEase.create('bouncy2', '0.25, 1.3, 0.5, 1.15');

const IOS_SNAP_BREAKPOINTS = [0.125, 0.375, 0.75];

const wishlists = [{
  name: 'Birthday',
  emoji: '🎂',
  itemsCount: 11,
}, {
  name: 'Sport',
  emoji: '⚽',
  itemsCount: 7,
}, {
  name: 'Sneakers',
  emoji: '🛹',
  itemsCount: 9,
}, {
  name: 'Books',
  emoji: '📚️️',
  itemsCount: 5,
}, {
  name: 'Christmas',
  emoji: '🎄',
  itemsCount: 8,
}, {
  name: 'Home',
  emoji: '🏠',
  itemsCount: 3,
}, {
  name: 'Dresses',
  emoji: '👗',
  itemsCount: 11,
}, {
  name: 'Tech',
  emoji: '🖥️',
  itemsCount: 7,
},
{
  name: 'Little things',
  emoji: '✨',
  itemsCount: 13,
}];

const wishlistsItems = [
  {
    name: 'Moritz Bootie House Slipper',
    url: 'https://target.com',
    currency: 'USD',
    currentPrice: 49.70,
    previousPrice: 70.00,
    image: '/images/landing/item-6.avif',
    user: '/images/landing/female-1.avif',
  },
  {
    name: 'Scented Candle',
    url: 'https://amazon.com',
    currency: 'USD',
    currentPrice: 12.99,
    previousPrice: 14.99,
    image: '/images/landing/item-5.avif',
    user: '/images/landing/female-6.avif',
  },
  {
    name: 'Nike Vomero Plus',
    url: 'https://nike.com',
    currency: 'USD',
    currentPrice: 180.00,
    image: '/images/landing/item-18.avif',
    user: '/images/landing/male-1.avif',
  },
  {
    name: 'Black athletic T-Shirt',
    url: 'https://amazon.com',
    currency: 'USD',
    currentPrice: 19.99,
    image: '/images/landing/item-3.avif',
    user: '/images/landing/male-4.avif',
  },
  {
    name: 'Table Lamp Set',
    url: 'https://wayfair.com',
    currency: 'USD',
    currentPrice: 87.99,
    previousPrice: 109.99,
    image: '/images/landing/item-16.avif',
    user: '/images/landing/female-8.avif',
  },
  {
    name: 'Hertford 26" Wood Chair',
    url: 'https://wayfair.com',
    currency: 'USD',
    currentPrice: 240.00,
    image: '/images/landing/item-15.avif',
    user: '/images/landing/male-7.avif',
  },
  {
    name: 'Sony WH-1000XM6',
    url: 'https://amazon.com',
    currency: 'USD',
    currentPrice: 398.00,
    previousPrice: 459.00,
    image: '/images/landing/item-1.avif',
    user: '/images/landing/male-2.avif',
  },
  {
    name: 'Logitech MX Master 4',
    url: 'https://amazon.com',
    currency: 'USD',
    currentPrice: 120.00,
    previousPrice: 129.00,
    image: '/images/landing/item-14.avif',
    user: '/images/landing/male-3.avif',
  },
  {
    name: 'Sweat dress in camel',
    url: 'https://asos.com',
    currency: 'USD',
    currentPrice: 24.00,
    previousPrice: 29.99,
    wishlist: wishlists[5],
    image: '/images/landing/item-13.avif',
    user: '/images/landing/female-4.avif',
  },
  {
    name: 'Mini dress in mono stripe',
    url: 'https://asos.com',
    currency: 'USD',
    currentPrice: 28.00,
    previousPrice: 35.00,
    image: '/images/landing/item-12.avif',
    user: '/images/landing/female-9.avif',
  },
  {
    name: 'Suede sneakers',
    url: 'https://puma.com',
    currency: 'USD',
    currentPrice: 110.00,
    image: '/images/landing/item-11.avif',
    user: '/images/landing/female-5.avif',
  },
  {
    name: 'Nike Air Force 1 \'07 LV8',
    url: 'https://nike.com',
    currency: 'USD',
    currentPrice: 115.00,
    previousPrice: 125.00,
    image: '/images/landing/item-4.avif',
    user: '/images/landing/male-6.avif',
  },
  {
    name: 'Fresh Cut Pine Candle',
    url: 'https://target.com',
    currency: 'USD',
    currentPrice: 35.00,
    previousPrice: 40.00,
    image: '/images/landing/item-10.avif',
    user: '/images/landing/female-7.avif',
  },
  {
    name: 'The Twang - Jewellery Quarter',
    url: 'https://bestbuy.com',
    currency: 'USD',
    currentPrice: 32.99,
    image: '/images/landing/item-9.avif',
    user: '/images/landing/male-5.avif',
  },
  {
    name: 'Gold Necklace',
    url: 'https://target.com',
    currency: 'USD',
    currentPrice: 40.00,
    image: '/images/landing/item-7.avif',
    user: '/images/landing/female-2.avif',
  },
  {
    name: '2-Layer Jewellery Case',
    url: 'https://bestbuy.com',
    currency: 'USD',
    currentPrice: 29.95,
    previousPrice: 39.95,
    image: '/images/landing/item-8.avif',
    user: '/images/landing/female-3.avif',
  },
];

const reviews = [{
  name: 'Ivan Bosko',
  description: 'This app is amazing! Intuitive, well-designed and works perfectly. Literally a must have if you shop online.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Andreas Müller',
  description: 'Shared a wishlist with my parents and they got me Gibson Flying V on my Birthday! Best day ever 🎉🎸',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Luba Pavlish',
  description: 'I love it, everything is so clean and organized. And I really like the emoji for each wishlist, so cute 😊',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Nikita Kolokoltsev',
  description: 'The value this app provides is insane. It has saved me hundreds of dollars and I\'m not even shopping that much.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Oleg Ud',
  description: 'Clean design with a smooth interface. Everything works fast and accurately. A solid 10/10 from me.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Ivan Bosko',
  description: 'This app is amazing! Intuitive, well-designed and works perfectly. Literally a must have if you shop online.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Andreas Müller',
  description: 'Shared a wishlist with my parents and they got me Gibson Flying V on my Birthday! Best day ever 🎉🎸',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Luba Pavlish',
  description: 'I love it, everything is so clean and organized. And I really like the emoji for each wishlist, so cute 😊',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Nikita Kolokoltsev',
  description: 'The value this app provides is insane. It has saved me hundreds of dollars and I\'m not even shopping that much.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}, {
  name: 'Oleg Ud',
  description: 'Clean design with a smooth interface. Everything works fast and accurately. A solid 10/10 from me.',
  store: 'chrome',
  rating: 5,
  link: EXTENSION_URL,
}];

const stores = [
  '/images/landing/stores/ikea.avif',
  '/images/landing/stores/sephora.avif',
  '/images/landing/stores/lego.avif',
  '/images/landing/stores/amazon.avif',
  '/images/landing/stores/target.avif',
  '/images/landing/stores/macys.avif',
  '/images/landing/stores/nordstrom.avif',
  '/images/landing/stores/asos.avif',
  '/images/landing/stores/north-face.avif',
  '/images/landing/stores/vans.avif',
  '/images/landing/stores/new-balance.avif',
  '/images/landing/stores/zara.avif',
  '/images/landing/stores/ikea.avif',
  '/images/landing/stores/sephora.avif',
  '/images/landing/stores/lego.avif',
  '/images/landing/stores/amazon.avif',
  '/images/landing/stores/target.avif',
  '/images/landing/stores/macys.avif',
  '/images/landing/stores/nordstrom.avif',
  '/images/landing/stores/asos.avif',
  '/images/landing/stores/north-face.avif',
  '/images/landing/stores/vans.avif',
  '/images/landing/stores/new-balance.avif',
  '/images/landing/stores/zara.avif',
];

const Page = () => {
  // ##########################################################################
  // STATE
  // ##########################################################################

  const heroBackgroundRef = useRef(null);
  const heroBackgroundItemsRef = useRef(null);
  const howItWorksTimelineRef = useRef(null);
  const howItWorksIOSRef = useRef(null);
  const featurePriceDropsRef = useRef(null);

  // ##########################################################################
  // EFFECTS
  // #########################################################################

  // How it Works - Mobile

  useGSAP(() => {
    const howItWorksIOS = howItWorksIOSRef.current;
    const trigger = howItWorksTimelineRef.current;
    const triggerStart = trigger.offsetTop - howItWorksIOS.offsetHeight;
    const triggerFinish = triggerStart + trigger.offsetHeight;

    const timeline = gsap.timeline({ paused: true });

    timeline
      .to(
        '[data-step="3"]',
        {
          y: 0,
          scale: 1,
          opacity: 1,
          duration: 0.5,
          ease: 'bouncy',
        },
      )
      .to(
        '[data-step="4"]',
        {
          scale: 1,
          borderRadius: '50%',
          duration: 0.5,
          ease: 'bouncy',
        },
        '<0.25',
      )
      .to(
        '[data-step="4"]',
        {
          opacity: 1,
          duration: 0.4,
          ease: 'bouncy',
        },
        '<',
      )
      .addLabel('step-1')
      .to(
        '[data-step="3"]',
        {
          y: '-3rem',
          opacity: 0,
          duration: 0.5,
          ease: 'bouncy',
        },
      )
      .to(
        '[data-step="4"]',
        {
          scale: 0.525,
          borderRadius: '10%',
          duration: 0.5,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="4"]',
        {
          opacity: 0,
          duration: 0.4,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="5"]',
        {
          opacity: 1,
          duration: 0.25,
          ease: 'power1.in',
        },
        '<',
      )
      .to(
        '[data-step="6"]',
        {
          backgroundPositionY: 0,
          duration: 0.25,
          ease: 'power1.in',
        },
        '<',
      )
      .to(
        '[data-step="7"]',
        {
          y: 0,
          opacity: 1,
          duration: 0.35,
          ease: 'bouncy',
        },
        '<0.25',
      )
      .to(
        '[data-step="8"]',
        {
          scale: 1,
          borderRadius: '50%',
          duration: 0.4,
          ease: 'bouncy',
        },
        '<0.25',
      )
      .to(
        '[data-step="8"]',
        {
          opacity: 1,
          duration: 0.32,
          ease: 'bouncy',
        },
        '<',
      )
      .addLabel('step-2')
      .to(
        '[data-step="6"]',
        {
          backgroundPositionY: '14rem',
          duration: 0.25,
          ease: 'power1.in',
        },
      )
      .to(
        '[data-step="7"]',
        {
          y: '-3.5rem',
          opacity: 0,
          duration: 0.35,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="8"]',
        {
          scale: 0.65,
          duration: 0.15,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="8"]',
        {
          opacity: 0,
          duration: 0.22,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="8"]',
        {
          y: '250%',
          duration: 0.3,
          ease: 'power1.in',
        },
        '<',
      )
      .to(
        '[data-step="9"]',
        {
          opacity: 1,
          duration: 0.25,
          ease: 'power1.in',
        },
        '<',
      )
      .to(
        '[data-step="10"]',
        {
          opacity: 1,
          duration: 0.32,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="10"]',
        {
          y: 0,
          duration: 0.4,
          ease: 'bouncy',
        },
        '<',
      )
      .to(
        '[data-step="11"]',
        {
          scale: 1,
          opacity: 1,
          duration: 0.4,
          ease: 'bouncy',
        },
        '<',
      )
      .addLabel('step-3');

    let currentStep = null;

    ScrollTrigger.create({
      start: triggerStart,
      end: triggerFinish,
      onUpdate: (scroll) => {
        const {
          isActive,
          progress,
        } = scroll;

        if (
          !isActive
        ) return;

        const index = IOS_SNAP_BREAKPOINTS.findIndex(i => progress < i) > -1
          ? IOS_SNAP_BREAKPOINTS.findIndex(i => progress < i)
          : IOS_SNAP_BREAKPOINTS.length;

        const newStep = index ? `step-${index}` : 0;

        if (
          newStep === currentStep
        ) return;

        currentStep = newStep;
        timeline.tweenTo(newStep);
      },
    });

  }, { scope: howItWorksIOSRef });

  // Features - Price Drops

  useGSAP(() => {
    const timeline = gsap.timeline({
      paused: true,
      defaults: {
        ease: 'bouncy2',
        duration: 0.35,
      },
    });

    timeline
      .to(
        '[data-price-drop]',
        {
          y: 0,
          scale: 1,
          opacity: 1,
        },
      );

    ScrollTrigger.create({
      trigger: '[data-price-drop]',
      start: 'top 50%',
      animation: timeline,
      toggleActions: 'play none none reverse',
    });
  }, { scope: featurePriceDropsRef });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <main className={styles.landing}>
      <div className={styles.header}>
        <Header
          withLogo
          withActions
        />
      </div>

      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.heroBlur} />

          <div
            ref={heroBackgroundRef}
            className={styles.heroBackground}
          >
            <div
              ref={heroBackgroundItemsRef}
              className={styles.heroBackgroundItems}
            >
              <img
                src="/images/landing/item-1.png"
                className={styles.heroBackgroundItem1}
              />
              <img
                src="/images/landing/item-2.png"
                className={styles.heroBackgroundItem2}
              />
              <img
                src="/images/landing/item-3.png"
                className={styles.heroBackgroundItem3}
              />
              <img
                src="/images/landing/item-4.png"
                className={styles.heroBackgroundItem4}
              />
              <img
                src="/images/landing/item-5.png"
                className={styles.heroBackgroundItem5}
              />
              <img
                src="/images/landing/item-6.png"
                className={styles.heroBackgroundItem6}
              />

              <img
                src="/images/landing/item-7.png"
                className={styles.heroBackgroundItem7}
              />
              <img
                src="/images/landing/item-8.png"
                className={styles.heroBackgroundItem8}
              />
              <img
                src="/images/landing/item-9.png"
                className={styles.heroBackgroundItem9}
              />
              <img
                src="/images/landing/item-10.png"
                className={styles.heroBackgroundItem10}
              />
            </div>
          </div>

          <div className={styles.heroText}>
            <Text
              as="h1"
              weight="600"
              className={styles.heroTitle}
              serif
            >
              Save
              &#32;
              <Text
                className={styles.heroHighlight}
                serif
              >
                everything
              </Text>
              &#32;
              you love
            </Text>

            <Text
              as="p"
              color="neutral-500"
              className={styles.heroSubtitle}
            >
              Organized space for every item you want - from any store. Create wishlists, track price&nbsp;drops, and share with friends.
            </Text>

            <div className={styles.heroInstall}>
              <InstallButton withRating />
            </div>

            <a
              href="https://www.producthunt.com/posts/dinosave-chrome-extension?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-dinosave&#0045;chrome&#0045;extension"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.heroProductHunt}
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=422483&theme=light"
                alt="Dinosave&#0032;–&#0032;Chrome&#0032;Extension - Discover&#0032;sales&#0044;&#0032;build&#0032;wishlists&#0032;and&#0032;share&#0032;it&#0032;with&#0032;the&#0032;world | Product Hunt"
              />
            </a>
          </div>

          <div className={styles.heroMedia}>
            <div className={styles.heroMediaBrowser}>
              <img src="/images/landing/browser.avif" />
            </div>

            <div className={styles.heroMediaBrowserDarken}>
              <img src="/images/landing/browser-darken.avif" />
            </div>

            <div className={styles.heroMediaExtension}>
              <img src="/images/landing/extension.avif" />
            </div>
          </div>
        </div>
      </section>

      <div className={styles.stores}>
        <Marquee
          speed={400}
          draggable
        >
          {stores.map((store, index) => (
            <img
              key={index}
              src={store}
            />
          ))}
        </Marquee>
      </div>

      <div
        ref={howItWorksIOSRef}
        className={styles.howItWorksIOS}
      >
        <Text
          as="h3"
          className={styles.howItWorksIOSTitle}
          serif
        >
          How it works
        </Text>

        <Text
          as="p"
          className={styles.howItWorksIOSSubtitle}
        >
          Simply share to Dinosave and we‘ll do the rest
        </Text>

        <div className={styles.howItWorksIOSSteps}>
          <div
            data-step="1"
            className={styles.howItWorksIOSStep1}
          />

          <div
            data-step="2"
            className={styles.howItWorksIOSStep2}
          />

          <div
            data-step="3"
            className={styles.howItWorksIOSStep3}
          >
            Tap &ldquo;Share&rdquo;
          </div>

          <img
            data-step="4"
            src="/images/landing/how-it-works/ios/share-icon.avif"
            className={styles.howItWorksIOSStep4}
          />

          <div
            data-step="5"
            className={styles.howItWorksIOSStep5}
          />

          <div
            data-step="6"
            className={styles.howItWorksIOSStep6}
          />

          <div
            data-step="7"
            className={styles.howItWorksIOSStep7}
          >
            Tap &ldquo;Dinosave&rdquo;
          </div>

          <img
            data-step="8"
            src="/images/landing/how-it-works/ios/dinosave-icon.avif"
            className={styles.howItWorksIOSStep8}
          />

          <div
            data-step="9"
            className={styles.howItWorksIOSStep9}
          />

          <img
            data-step="10"
            src="/images/landing/how-it-works/ios/item-notification.avif"
            className={styles.howItWorksIOSStep10}
          />

          <img
            data-step="11"
            src="/images/landing/how-it-works/ios/relieved.avif"
            className={styles.howItWorksIOSStep11}
          />

          <div className={styles.howItWorksIOSShadow} />

          <ProgressShape className={styles.howItWorksIOSTopProgress} />
          <ProgressShape className={styles.howItWorksIOSBottomProgress} />
        </div>
      </div>

      <div
        ref={howItWorksTimelineRef}
        className={styles.howItWorksTimeline}
      />

      <section className={styles.features}>
        <div className={styles.featuresBackground}>
          <div className={styles.featuresBackgroundBlob1} />
          <div className={styles.featuresBackgroundBlob2} />
          <div className={styles.featuresBackgroundBlob3} />
          <div className={styles.featuresBackgroundBlob4} />
          <div className={styles.featuresBackgroundBlob5} />
          <div className={styles.featuresBackgroundBlob6} />
        </div>

        <div className={styles.featureWishlists}>
          <div className={styles.featureBackground}>
            <img
              src="/images/landing/item-5.png"
              className={styles.featureBackgroundImage1}
            />
            <img
              src="/images/landing/item-6.png"
              className={styles.featureBackgroundImage2}
            />
          </div>

          <div className={styles.featureContent}>
            <div className={styles.featureText}>
              <Text
                kind="label"
                color="neutral-500"
                className={styles.featureSub}
              >
                CREATE
              </Text>

              <Text
                as="h3"
                weight="600"
                className={styles.featureTitle}
                serif
              >
                Wishlists
              </Text>

              <Text
                as="p"
                color="neutral-500"
                className={styles.featureDescription}
              >
                Save items from online stores into one beautiful, organized space.
                No more lost bookmarks.
              </Text>
            </div>

            <div className={styles.featureBody}>
              <Marquee className={styles.marquee}>
                {wishlists?.slice(0,5)?.map((wishlist, index) => (
                  <WishlistLinkStatic
                    key={index}
                    wishlist={wishlist}
                  />
                ))}
              </Marquee>
              <Marquee
                className={styles.marquee}
                reversed
              >
                {wishlists?.slice(5, 9)?.map((wishlist, index) => (
                  <WishlistLinkStatic
                    key={index}
                    wishlist={wishlist}
                  />
                ))}
              </Marquee>
            </div>
          </div>
        </div>

        <div className={styles.featureFriends}>
          <div className={styles.featureBackground}>
            <img
              src="/images/landing/woman.avif"
              className={styles.featureBackgroundImage1}
            />

            <img
              src="/images/landing/item-12.png"
              className={styles.featureBackgroundImage2}
            />
          </div>
          <div className={styles.featureContent}>
            <div className={styles.featureText}>
              <Text
                kind="label"
                color="neutral-500"
                className={styles.featureSub}
              >
                ADD
              </Text>

              <Text
                as="h3"
                weight="600"
                className={styles.featureTitle}
                serif
              >
                Friends
              </Text>

              <Text
                as="p"
                color="neutral-500"
                className={styles.featureDescription}
              >
                Discover what your friends are wishing for and surprise them with a perfect present!
              </Text>
            </div>

            <div className={styles.featureBody}>
              <Marquee className={styles.marquee}>
                {wishlistsItems?.slice(0, 8)?.map((item, index) => (
                  <ItemStatic
                    key={index}
                    item={item}
                  />
                ))}
              </Marquee>
              <Marquee
                className={styles.marquee}
                reversed
              >
                {wishlistsItems?.slice(8, 17)?.map((item, index) => (
                  <ItemStatic
                    key={index}
                    item={item}
                  />
                ))}
              </Marquee>
            </div>
          </div>
        </div>

        <div
          ref={featurePriceDropsRef}
          className={styles.featurePriceDrops}
        >
          <div className={styles.featurePriceDropsBlur} />

          <div className={styles.featureBackground}>
            <div className={styles.featureBackgroundPrice1}>
              <Text
                weight="700"
                className={styles.featureBackgroundPriceText}
              >
                $115.99
              </Text>
            </div>

            <div className={styles.featureBackgroundPrice2}>
              <Text
                weight="700"
                className={styles.featureBackgroundPriceText}
              >
                €57.99
              </Text>
            </div>

            <div className={styles.featureBackgroundPrice3}>
              <Text
                weight="700"
                className={styles.featureBackgroundPriceText}
              >
                £73.99
              </Text>
            </div>

            <div className={styles.featureBackgroundPrice4}>
              <Text
                weight="700"
                className={styles.featureBackgroundPriceText}
              >
                $30.99
              </Text>
            </div>

            <div className={styles.featureBackgroundPrice5}>
              <Text
                weight="700"
                className={styles.featureBackgroundPriceText}
              >
                €23.99
              </Text>
            </div>

            <img
              src="/images/landing/item-11.png"
              className={styles.featureBackgroundImage1}
            />
            <img
              src="/images/landing/item-13.png"
              className={styles.featureBackgroundImage2}
            />
            <img
              src="/images/landing/item-14.png"
              className={styles.featureBackgroundImage3}
            />
          </div>

          <div className={styles.featureContent}>
            <div className={styles.featureText}>
              <Text
                kind="label"
                color="neutral-500"
                className={styles.featureSub}
              >
                GET
              </Text>

              <Text
                as="h3"
                weight="600"
                className={styles.featureTitle}
                serif
              >
                Price drops
              </Text>

              <Text
                as="p"
                color="neutral-500"
                className={styles.featureDescription}
              >
                Stop checking websites for sales. Dinosave tracks your items and notifies you when prices drop.
              </Text>
            </div>

            <div className={styles.featureBody}>
              <img
                className={styles.featurePriceDropsPhone1}
                src="/images/landing/iphone.avif"
              />
              <img
                className={styles.featurePriceDropsPhone2}
                src="/images/landing/iphone-2.avif"
              />
              <img
                className={styles.featurePriceDropsPhone3}
                src="/images/landing/iphone-3.avif"
              />

              <div className={styles.featurePriceDropsAnimation}>
                <div
                  className={styles.priceDrop1}
                  data-price-drop="1"
                >
                  <div className={styles.priceDropHead}>
                    <img
                      src="/images/logo/icon.png"
                      className={styles.priceDropHeadLogo}
                    />

                    <Text weight="500">
                      Dinosave
                    </Text>

                    <Text
                      weight="500"
                      className={styles.priceDropHeadTimestamp}
                    >
                      just now
                    </Text>
                  </div>

                  <div className={styles.priceDropBody}>
                    <div className={styles.priceDropBodyText}>
                      <Text weight="600">
                        25% discount found
                      </Text>
                      <Text weight="500">
                        $19.50 off on Nike Air Force 1 '07 LV8
                      </Text>
                    </div>

                    <img
                      src="/images/landing/notification-item-1.avif"
                      className={styles.priceDropBodyImage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.reviews}>
        <div className={styles.reviewsBackground} />

        <div className={styles.reviewsBody}>
          <Text
            as="h3"
            kind="super"
            color="neutral"
            className={styles.reviewsTitle}
            serif
          >
            What our users&nbsp;say
          </Text>

          <div className={styles.reviewsSlider}>
            <Swiper
              modules={[Autoplay]}
              spaceBetween={0}
              slidesPerView="auto"
              autoplay={{
                delay: 4000,
              }}
              centeredSlides
              loop
            >
              {reviews.map((review, index) =>  (
                <SwiperSlide key={index}>
                  <ReviewStatic
                    review={review}
                    className={styles.review}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>


          <div className={styles.reviewsInstall}>
            <Text
              as="h2"
              kind="super"
              color="neutral"
              className={styles.reviewsInstallTitle}
              serif
            >
              Install
              &#32;
              <Text
                className={styles.reviewsInstallHighlight}
                serif
              >
                Dinosave
              </Text>
            </Text>

            <Text
              kind="paragraph"
              className={styles.reviewsInstallSubtitle}
            >
              And see for yourself.
            </Text>

            <div className={styles.reviewsInstallButton}>
              <InstallButton
                color="neutral"
                withRating
              />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.cta}>
        <Text
          as="h2"
          kind="super"
          color="neutral-600"
          className={styles.ctaTitle}
          serif
        >
          Install
          &#32;
          <Text
            className={styles.ctaHighlight}
            serif
          >
            Dinosave
          </Text>
        </Text>

        <Text
          kind="paragraph"
          color="neutral-600"
          className={styles.ctaSubtitle}
        >
          And see for yourself.
        </Text>

        <div className={styles.ctaButton}>
          <InstallButton
            color="neutral-600"
            withRating
          />
        </div>
      </section>

      <Footer
        kind="fixed"
        className={styles.footer}
      />
    </main>
  );
};

export default Page;
